module.exports = __webpack_public_path__ + "img/gold1.1a593384.png";